const Chip = ({ text }) => {
  return <div className="chip">{text}</div>;
};

export default Chip;
